import React, { ReactElement } from 'react';

export interface FolderFeedbackHeadingProps {
  folderName: string;
  ownerName: string;
}

export default function FolderFeedbackHeading({
  folderName,
  ownerName = '',
}: FolderFeedbackHeadingProps): ReactElement {
  return (
    <>
      <h1>{folderName}</h1>

      <p>
        Your teammate {ownerName} is requesting feedback from you on the
        following folder.
      </p>
    </>
  );
}
